import { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import MultiCheckboxSelect from './filtro_custom_produtos';
import SelectInput from '../../../../Misc/SelectInput/SelectInput';
import { usePAChecklistFollowUp } from '../../pa_checklist_followup_context';
import { useMisc } from '../../../../../contexts/MiscContext';
import { api } from '../../../../../services/api';
import { toast } from 'react-toastify';
import styles from '../../pa_checklist_followup.module.scss';
import CookiesService from '../../../../../services/cookies';

const ModalDispensaFup = () => {
  const { showDispensa, setShowDispensa, listaProdutosDispensa, setListaProdutosDispensa, listaStatus } = usePAChecklistFollowUp();
  const { setShowLoading } = useMisc();
  const [produtosSelecionados, setProdutosSelecionados] = useState([]);
  const [tipoDispensa, setTipoDispensa] = useState('');
  const [statusFinal, setStatusFinal] = useState(null);
  const [showDispensaConfirmacao, setShowDispensaConfirmacao] = useState(false);

  const isDispensaTotal = tipoDispensa === 'total';

  const handleConfirmar = async () => {
    try {
      setShowLoading(true);
      const params = {
        produtos: produtosSelecionados.map(p => p.value),
        status_final: isDispensaTotal ? statusFinal?.value : null,
        id_usuario_responsavel: CookiesService.getUserId(),
        login_usuario_responsavel: CookiesService.getUserLogin()
      }

      if (tipoDispensa === 'parcial') await api.post('pa/checklist-fup/dispensar-produtos-parcial', params);
      if (tipoDispensa === 'total') await api.post('pa/checklist-fup/dispensar-produtos-total', params);
      toast.success('Dispensa realizada com sucesso!');
    } catch (e) {
      toast.error('Ocorreu um erro durante o processamento da dispensa de etapas. Por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  const handleSetProdutosSelecionados = (arr) => {
    if (produtosSelecionados.length > 9) return toast.warning('Há um limite de 10 produtos diferentes por dispensa.');
    setProdutosSelecionados([...arr]);
  }

  const resetForm = () => {
    setProdutosSelecionados([]);
    setTipoDispensa('');
    setStatusFinal(null);
  }

  useEffect(() => {
    if (!showDispensa) resetForm();
  }, [showDispensa]);

  useEffect(() => {
    (async () => {
      const res = await api.get('pa/checklist-fup/checklist-fup-lista-dispensa');
      setListaProdutosDispensa([...res.data]);
    })();
  }, []);

  return (
    <>
      <Modal
        show={showDispensa}
        onHide={() => setShowDispensa(false)}
        centered
        size="md"
        backdropClassName={styles.backdrop_z_override}
      >
        <Modal.Header style={{ fontWeight: '500' }} closeButton>Dispensar Etapas</Modal.Header>
        <Modal.Body>
          <Form.Group controlId='selectProdutos' className='mb-3'>
            <MultiCheckboxSelect
              options={listaProdutosDispensa || []}
              value={produtosSelecionados}
              onChange={e => handleSetProdutosSelecionados(e)}
              placeholder='Selecione os produtos (máximo de 10 produtos por dispensa)'
              width={'100%'}
            />
          </Form.Group>

          <Form.Group controlId='tipoDispensa' className='mb-3' style={{ width: '100%' }}>
            <Form.Label className={styles.form_label}>Tipo de Dispensa</Form.Label>
            <div>
              <Form.Check
                id='dispensa-total'
                inline
                type='radio'
                label='Dispensa Total'
                value='total'
                name='dispensa'
                checked={tipoDispensa === 'total'}
                style={{ fontSize: '16px' }}
                onChange={e => { setTipoDispensa(e.target.value); setStatusFinal(null); }}
              />
              <Form.Check
                id='dispensa-parcial'
                inline
                type='radio'
                label='Dispensa Parcial'
                value='parcial'
                name='dispensa'
                checked={tipoDispensa === 'parcial'}
                style={{ fontSize: '18px' }}
                onChange={e => setTipoDispensa(e.target.value)}
              />
            </div>
          </Form.Group>

          <Form.Group controlId='statusFinal'>
            <SelectInput
              label={'Status Final (exclusivo para dispensa total)'}
              options={listaStatus.filter(item => [57, 70].includes(item.value))}
              value={statusFinal}
              onChange={e => setStatusFinal(e)}
              placeholder='Selecione o status final'
              isDisabled={!isDispensaTotal}
              isClearable={true}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant='secondary'
            onClick={() => setShowDispensa(false)}
            style={{ fontWeight: '500', marginRight: 'auto' }}
          >
            Cancelar
          </Button>
          <Button
            variant='primary'
            onClick={() => setShowDispensaConfirmacao(true)}
            disabled={produtosSelecionados.length === 0 || !tipoDispensa || (isDispensaTotal && !statusFinal)}
            style={{ fontWeight: '500' }}
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de confirmação */}
      <Modal
        show={showDispensaConfirmacao}
        onHide={() => setShowDispensaConfirmacao(false)}
        centered
        size="md"
        backdropClassName={styles.backdrop_z_override}
      >
        <Modal.Header style={{ fontWeight: '500' }} closeButton>Confirmação de Dispensa</Modal.Header>
        <Modal.Body>
          <div>Confirma a dispensa <span style={{ fontWeight: '500' }}>{isDispensaTotal ? 'total' : 'parcial'}</span> dos produtos abaixo?</div>
          {produtosSelecionados.map((prod, i) => {
            return <span key={`prod_${i}`} style={{ fontWeight: '500' }}>
              {prod.label}{i === produtosSelecionados.length - 1 ? '' : ' | '}
            </span>
          })}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='secondary'
            onClick={() => setShowDispensaConfirmacao(false)}
            style={{ fontWeight: '500', marginRight: 'auto' }}
          >
            Cancelar
          </Button>
          <Button
            variant='success'
            onClick={handleConfirmar}
            disabled={produtosSelecionados.length === 0 || !tipoDispensa || (isDispensaTotal && !statusFinal)}
            style={{ fontWeight: '500' }}
          >
            Processar Dispensa
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalDispensaFup;
